import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import css from './IconRadical.module.css';

const IconRadical = props => {
  const { className, rootClassName } = props;
  const classes = clsx(rootClassName || css.root, className);

  return (
    <svg
      className={classes}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.17 16C21.705 14.775 22 13.42 22 12C22 6.475 17.525 2 12 2C6.475 2 2 6.475 2 12H12L12.005 16C12.005 17.935 13.57 19.5 15.505 19.5C17.44 19.5 19.005 17.935 19.005 16H21.17Z"
        stroke="#6E7191"
        strokeWidth="2"
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 17C16.05 17 16.5 16.55 16.5 16C16.5 15.45 16.05 15 15.5 15C14.95 15 14.5 15.45 14.5 16C14.5 16.55 14.95 17 15.5 17Z"
        fill="#6E7191"
      />
      <path
        d="M12 16L3 18C4.115 19.585 5.225 21.185 7 22L13 18.5"
        stroke="#6E7191"
        strokeWidth="2"
        strokeMiterlimit="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const { string } = PropTypes;

IconRadical.defaultProps = {
  className: null,
  rootClassName: null,
};

IconRadical.propTypes = {
  className: string,
  rootClassName: string,
};

export default IconRadical;
